export const currencyCodeMap: { [index: string]: string } = {
  EUR: `€`,
  BRL: `R$`,
  TRY: `₺`,
  RMB: `¥`,
  CNY: `¥`,
  USD: `US$`,
  INR: `₹`,
  JPY: `¥`,
  THB: `฿`,
  ARS: `$`,
  VND: `₫`,
  MYR: `RM`,
  UYU: `$`,
  IDR: `Rp`,
  TWD: `NT$`,
  CAD: `$`,
  PYG: `₲`,
  CLP: `$`,
  COP: `$`,
  MXN: `$`,
  BOB: `Bs.`,
  GBP: `£`,
  PEN: `S/.`,
  AED: `د.إ`,
  SAR: `ر.س`,
  RUB: `₽`,
  SEK: `kr`,
  NGN: `₦`,
  ZAR: `R`,
  KES: `KSh`,
  GHS: `₵`,
  AUD: `$`,
  XOF: `CFA`,
  PAB: `B/.`,
  DKK: `kr`,
  NOK: `kr`,
  KRW: `₩`,
  GTQ: `Q`,
  HNL: `L`,
  NIO: `C$`,
  SVC: `$`,
  MAD: `د.م.`,
  UGX: `USh`,
  TZS: `TSh`,
  BDT: `৳`,
  PKR: `₨`,
  XAF: `FCFA`,
  CDF: `FC`,
  CZK: `Kč`,
  NZD: `$`,
  AND: `€`,
  ZWD: `$`,
  MZN: `MT`,
  UAH: `₴`,
  RSD: `РСД`,
  PLN: `zł`,
  EGP: `£`,
  KWD: `د.ك`,
  MNT: `₮`,
  MMK: `K`,
  SLL: `Le`,
  TTD: `$`,
  NPR: `₨`,
  LKR: `₨`,
  LSL: `L`,
  AOA: `Kz`,
  UZS: `so'm`,
  KZT: `₸`,
  MGA: `Ar`,
  RWF: `FRw`,
  ZWL: `$`,
  ETB: `Br`,
  QAR: `﷼`,
  TND: `د.ت`,
  HUF: `Ft`,
  MKD: `ден`,
  HKD: `$`,
  MOP: `MOP$`,
  BGN: `лв`,
};
